import classNames from 'classnames';
import { ParseMarkdown } from '@/components/markdown';

const Description = ({
  sliderPreset,
  description,
}: {
  sliderPreset: boolean;
  description: string;
}) => (
  <div
    className={classNames(
      'flex w-full flex-col py-4 xs:py-6 lg:py-4',
      {
        'items-start justify-start': sliderPreset,
      },
      {
        'mt-[15vh] !h-full w-full items-center justify-start': !sliderPreset,
      },
    )}
  >
    <div
      className={classNames(
        ' text-gray-700 lg:text-xs',
        {
          'text-left text-xs xs:text-sm': sliderPreset,
        },
        {
          'text-center text-xs xxs:text-sm': !sliderPreset,
        },
      )}
    >
      <div className="mt-1">
        <ParseMarkdown variables={{}} size="base" markdown={description} />
      </div>
    </div>
  </div>
);

export default Description;
